var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAward = function SvgAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.993a6.24 6.24 0 0 1 6.24 6.24c0 1.96-.904 3.707-2.317 4.85l1.362 7.659v.005a1.07 1.07 0 0 1-.518 1.103 1.07 1.07 0 0 1-1.194-.084v.001l-3.366-2.525v-.001a.34.34 0 0 0-.407 0l-3.37 2.526-.003-.002c-.164.128-.36.208-.568.225a1.07 1.07 0 0 1-1.142-1.242l.001-.006 1.36-7.657A6.24 6.24 0 0 1 12 1.992m2.832 11.8a6.2 6.2 0 0 1-2.832.68 6.2 6.2 0 0 1-2.832-.68l-1.212 6.829 3.126-2.34a1.54 1.54 0 0 1 1.843 0h.001l3.12 2.342zM12 3.191a5.041 5.041 0 1 0 0 10.083 5.041 5.041 0 0 0 0-10.083"
  })));
};
export default SvgAward;